export default __webpack_public_path__ + "static/media/kafein-logo-white.1249416f.png";